<template>
  <div class="m-footer">
    <h1>Footer</h1>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue